import styled from "styled-components";

export const Wrapper = styled.div`
    height: 100%;
    min-height: 100%;
    width: 100%;
    position: relative;
    box-sizing: border-box;
    //@media(max-height: 940px) {
    //    height: calc(100vh - 110px);
    //    width: 390px;
    //}
    //@media(max-height: 940px) {
    //  height: calc(100% - 160px - 110px);
    //}
    //@media(max-height: 900px) {
    //  height: calc(100% - 162px - 110px);
    //}
    //@media(max-height: 850px) {
    //  height: calc(100% - 149px - 130px);
    //}
    //@media(max-height: 800px) {
    //    height: 100%
    //  //height: calc(100% - 100px - 130px);
    //  //height: calc(100% - 100px - 130px);
    //}
    //// desktop version
    //@media(max-height: 650px) {
    //  height: calc(100% - 70px - 130px);
    //}
  //border: 1px solid #333;
  //background: #1e1f24;
`

export const List = styled.div`
    //height: calc(100% - 200px);
    width: 100%;
    height: 100%;
    min-height: 100%;
    overflow-y: scroll;
    padding: 0;
    box-sizing: border-box;
    contain: layout paint;
    //display: flex;
    //flex-direction: column-reverse;
    &::-webkit-scrollbar {
        width: 0;
    }

  //@media(max-height: 940px) {
  //  height: calc(100% - 160px);
  //}
  //@media(max-height: 900px) {
  //  height: calc(100% - 162px);
  //}
  //@media(max-height: 850px) {
  //  height: calc(100% - 149px);
  //}
  //@media(max-height: 800px) {
  //  height: calc(100% - 100px);
  //}
  //// desktop version
  //@media(max-height: 650px) {
  //  height: calc(100% - 70px);
  //}
`

export const Row = styled.div<{$isHighlighted?: boolean, isFavorite: boolean}>`
    //height: 49px;
    height: 67px;
    display: flex;
    width: 100%;
    align-items: center;
    color: ${({$isHighlighted }) => ($isHighlighted ? '#23AF91' : 'white')};
    align-content: center;
    border-bottom: 2px solid rgba(146, 154, 165, 0.08);
    
    font-size: 13px;
    letter-spacing: 0.6px;
    cursor: default;
    box-sizing: border-box;
    text-wrap: nowrap;
    position: relative;
    background: ${({isFavorite}) => isFavorite ? '#ffffff10' : 'none' };
    @media (max-height: 940px) {
        height: 60px;
        padding: 0 25px;
        //font-size: 12px;
        //&:hover {
        //    cursor: pointer;
        //    background: #5B71BF;
        //    color: white;
        //}
   }
`
export const Market = styled.div`
    width: 50%;
    overflow: hidden;
    padding-right: 5px;
    font-size: 12px;
`
export const Profit = styled.div`
    width: 20%;
    align-content: center;
    overflow: hidden;
    //padding-left: 3px;
`
export const Time = styled.div<{ $isHighlighted?: boolean }>`
    width: 30%;
    text-align: end;
    align-content: center;
    // color: ${({ $isHighlighted }) => ($isHighlighted ? 'white' : '#929AA5')};
    color: #929AA5;
    overflow: hidden;
    //padding-right: 3px;
`
export const CustomScrollLine = styled.div`
    position: absolute;
    background: rgb(62 68 105);
    width: 4px;
    height: 100%;
    left: 37px;
    
    @media (max-height: 940px) {
        width: 3px;
        left: 20px;
        //height: calc(100% - 159px);
    }
  //  @media(max-height: 900px) {
  //    height: calc(100% - 161px);
  //  }
  //  @media (max-height: 850px) {
  //    height: calc(100% - 147px);
  //  }
  //  @media (max-height: 800px) {
  //    height: calc(100% - 100px);
  //  } 
  //@media (max-height: 650px) {
  //    height: calc(100% - 70px);
  //  }
`